import FileTags from './redux'
export default FileTags
